export enum QuestionCodeEnum {
  EXPERIENCE_THUMBS = 'EXPERIENCE_THUMBS',
  HELPFUL_THUMBS = 'HELPFUL_THUMBS',
  HELPFUL_WHY = 'HELPFUL_WHY',
}
